/** Política de senha — cadastros e trocas novas (mesma regra do backend). */

export const PASSWORD_MIN_LENGTH = 8;

export const PASSWORD_POLICY_MESSAGE =
  'A senha deve ter pelo menos 8 caracteres, incluindo letras e números.';

export const PASSWORD_POLICY_HINT =
  'Use pelo menos 8 caracteres, com letras e números. Símbolos (@, #, etc.) são opcionais, mas recomendados.';

export function validateNewPassword(password) {
  const pwd = password || '';
  if (pwd.length < PASSWORD_MIN_LENGTH) return PASSWORD_POLICY_MESSAGE;
  if (!/[A-Za-zÀ-ÖØ-öø-ÿ]/.test(pwd)) return PASSWORD_POLICY_MESSAGE;
  if (!/\d/.test(pwd)) return PASSWORD_POLICY_MESSAGE;
  return null;
}
